import React, { FC } from "react";
import { OidcLogoutActions } from "firefly-shared-ts-authentication-oidc";
import { Logout } from "./Logout";


export const LogoutAction: FC = () => {
  return <Logout action={OidcLogoutActions.Logout} />;
};
